import React from 'react';

export const PyTorchSvg = () => {
  return (
    <svg
      width="112"
      height="29"
      viewBox="0 0 112 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_16722_14293)">
        <path
          d="M15.2318 7.52396L13.7306 9.05123C16.1871 11.5504 16.1871 15.5768 13.7306 18.0297C11.274 20.5289 7.31624 20.5289 4.90517 18.0297C2.44862 15.5306 2.44862 11.5041 4.90517 9.05123L8.79472 5.09421L9.34063 4.53883V1.55371L3.47218 7.52396C0.196772 10.8562 0.196772 16.2248 3.47218 19.557C6.74759 22.8892 12.0246 22.8892 15.2318 19.557C18.5072 16.2016 18.5072 10.8562 15.2318 7.52396Z"
          fill="white"
        />
        <path
          d="M13.3897 6.04287C13.3897 6.65633 12.9009 7.15362 12.2979 7.15362C11.6949 7.15362 11.2061 6.65633 11.2061 6.04287C11.2061 5.42942 11.6949 4.93213 12.2979 4.93213C12.9009 4.93213 13.3897 5.42942 13.3897 6.04287Z"
          fill="white"
        />
        <path
          d="M30.4032 15.1602H27.8784V21.7552H25.9678V2.98828H30.6079C35.4528 2.98828 37.7729 5.41803 37.7729 8.81969C37.8411 13.0081 34.9752 15.1602 30.4032 15.1602ZM30.6079 4.86266C30.4032 4.86266 27.9467 4.86266 27.9467 4.86266V13.4941L30.5397 13.4246C34.0198 13.3552 35.9305 11.9668 35.9305 9.05109C35.9305 6.32051 34.0198 4.86266 30.6079 4.86266Z"
          fill="white"
        />
        <path
          d="M46.3255 21.6859L45.2337 24.671C44.0054 28.0033 42.7089 28.9752 40.8665 28.9752C39.8429 28.9752 39.0923 28.6975 38.2734 28.3504L38.8193 26.6148C39.4335 26.9619 40.1159 27.2396 40.8665 27.2396C41.89 27.2396 42.6407 26.6843 43.6642 24.0462L44.5513 21.6165L39.297 8.05615H41.2759L45.5066 19.395L49.6691 8.05615H51.5798L46.3255 21.6859Z"
          fill="white"
        />
        <path
          d="M57.8122 4.86258V21.8246H55.9015V4.86258H49.4189V3.05762H64.2493V4.86258C64.2265 4.86258 57.8122 4.86258 57.8122 4.86258Z"
          fill="white"
        />
        <path
          d="M69.6398 22.1717C65.8867 22.1717 63.1572 19.3254 63.1572 14.9519C63.1572 10.5783 66.0232 7.6626 69.8445 7.6626C73.6658 7.6626 76.3271 10.5089 76.3271 14.8824C76.2589 19.256 73.3929 22.1717 69.6398 22.1717ZM69.7081 9.39814C66.8421 9.39814 64.9996 11.689 64.9996 14.9519C64.9996 18.2841 66.9103 20.575 69.7763 20.575C72.6423 20.575 74.4847 18.2841 74.4847 15.0213C74.4847 11.6196 72.574 9.39814 69.7081 9.39814Z"
          fill="white"
        />
        <path
          d="M80.8991 21.8248H79.0566V8.05618L80.8991 7.63965V10.5554C81.7861 8.81981 83.0827 7.63965 84.8568 7.63965C85.7439 7.63965 86.5628 7.91733 87.2452 8.26444L86.7675 9.99998C86.1534 9.65287 85.471 9.37519 84.7204 9.37519C83.2874 9.37519 81.9909 10.4859 80.8991 12.9157V21.8248Z"
          fill="white"
        />
        <path
          d="M94.4325 22.1717C90.3383 22.1717 87.8135 19.1866 87.8135 14.9519C87.8135 10.6477 90.6112 7.6626 94.4325 7.6626C96.0702 7.6626 97.5032 8.07913 98.6633 8.84276L98.1856 10.5089C97.162 9.81466 95.8655 9.39814 94.4325 9.39814C91.4983 9.39814 89.7241 11.6196 89.7241 14.8824C89.7241 18.2147 91.6348 20.4362 94.5008 20.4362C95.8655 20.4362 97.2303 20.0196 98.2538 19.3254L98.6633 21.0609C97.435 21.7552 96.002 22.1717 94.4325 22.1717Z"
          fill="white"
        />
        <path
          d="M109.946 21.8247V12.9156C109.946 10.4858 108.991 9.44451 107.08 9.44451C105.511 9.44451 104.009 10.2776 102.918 11.3883V21.8247H101.075V1.59988L102.918 1.18335V9.88418C104.351 8.42632 106.125 7.73211 107.626 7.73211C110.219 7.73211 111.857 9.46765 111.857 12.4528V21.8478H109.946V21.8247Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_16722_14293">
          <rect
            width="111"
            height="28"
            fill="white"
            transform="translate(0.878906 0.975098)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
